<template lang="pug">
.modal-backdrop(v-if="value" @touchmove.prevent :style='backGround')
  slot
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: String,
      default: '0.49',
    },
  },
  data() {
    return {
      backGround: '',
    };
  },
  created() {
    this.backGround = `background:rgba(0, 0, 0, ${this.opacity})`;
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.49);
}
</style>
